// Single source of truth for how a user reaches us.
//
// PointClickCare's technical validation requires that technical errors are not
// shown to end users — a 400 or a 429 means nothing to a DON. What replaces them
// has to tell the user what to DO, and "contact support" is only useful if the
// support address is right there. The Support panel in the footer already
// carries these details, so they live here and both read from the same place:
// an error message that names a stale address is worse than one that names none.
export const SUPPORT_EMAIL = "notifications@survaihealth.com";
export const SUPPORT_PHONE = "1-586-206-4319";
export const SUPPORT_HOURS = "response within one business day";

// Appended to a failure message so the user always has a next step. Kept short —
// a toast that wraps to four lines does not get read.
export const CONTACT_SHORT = `contact ${SUPPORT_EMAIL} or ${SUPPORT_PHONE}`;
export const CONTACT_LINE = `If this keeps happening, ${CONTACT_SHORT}.`;

// msg + the contact line, with sensible spacing and no double punctuation.
export function withSupport(msg) {
  const base = String(msg || "").trim();
  if (!base) return CONTACT_LINE;
  if (base.includes(SUPPORT_EMAIL)) return base; // already carries it
  return `${base}${/[.!?]$/.test(base) ? "" : "."} ${CONTACT_LINE}`;
}
